import { isAnnotationIdLocked } from '../utils/annotationLockUtils';
import reorderAnnotationsInStack from '../utils/reorderAnnotationsInStack';

export const UPDATE_ZINDEX_ANNOTATIONS = 'UPDATE_ZINDEX_ANNOTATIONS';

const updateZIndexAnnotations = (state, payload) => {
  if (
    !state.designLayer ||
    !state.annotations[payload.id] ||
    isAnnotationIdLocked(state.annotations, payload.id)
  ) {
    return state;
  }

  const annotations = reorderAnnotationsInStack(
    state.annotations,
    payload.id,
    'front',
  );

  if (annotations === state.annotations) {
    return state;
  }

  return {
    ...state,
    isDesignState: payload.isDesignState ?? true,
    annotations,
  };
};

export default updateZIndexAnnotations;
